function getWindowData(slice) {
  var _ref, _window$dataBlobs;
  return (_ref = typeof window !== 'undefined' && ((_window$dataBlobs = window.dataBlobs) === null || _window$dataBlobs === void 0 ? void 0 : _window$dataBlobs[slice])) !== null && _ref !== void 0 ? _ref : null;
}
export default getWindowData;